module.exports = __webpack_public_path__ + "17_hair_gold.b7e4fc87.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/17_hair_gold.png
// module id = dgPj
// module chunks = 0